module.exports = __webpack_public_path__ + "static/media/9_FR.592cfebc.mp3";